<template>
  <div id="app">
    <div class="loader-wrapper" v-if="loading">
      <div class="spinner spinner-1"></div>
      <!-- <div class="loader-cube">
        <div class="back side"></div>
        <div class="left side"></div>
        <div class="right side"></div>
        <div class="top side"></div>
        <div class="bottom side"></div>
        <div class="front side"></div>
      </div> -->
    </div>
  
    <router-view></router-view>
  
    <Overlay></Overlay>
    <Timeout></Timeout>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Hall from "@/components/Hall";

import Overlay from "@/components/Overlay";
import Timeout from "@/components/Timeout";

export default {
  computed: mapState(["loading", "user"]),
  components: {
    Hall,
    Overlay,
    Timeout,
  },
};
</script>

<style lang="scss">
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  vertical-align: baseline;
}

/* HTML5 display-role reset for older browsers */

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

body {
  line-height: 1;
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

html {
      /*overflow-y: hidden;*/
      max-height: 620px;
}

html,
body,
#app {
  height: 100%;
}

body {
  background-color: #24262c;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000;
}

a {
  text-decoration: none;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: transparent;
  border-radius: 10px;
}

::-webkit-scrollbar {
  width: 6px;
  background-color: #f5f5f5;
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: #0d76ff;
  border-radius: 10px;
}

.loader-wrapper {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10003;
  background-color: #000000ef;
  $color: #0d76ff;
  $size: 10px;
  $time: 1.25;

  main {
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background:  #090707;
  }

  $basic-dark-color: #0d76ff; //color of the spinner
  $border-width: 4px; //width of spinners border
  $basic-spinner-dimensions: 125px; //width and height of spinner
  $main-spinner-dimensions: $basic-spinner-dimensions - $border-width * 2; //width and height of bigger circle
  $small-spinner-dimensions: $main-spinner-dimensions * 0.7; 

  .spinner {
    position: relative;
    width: $basic-spinner-dimensions;
    height: $basic-spinner-dimensions;

    &:before,
    &:after {
      content: "";
      display: block;
      position: absolute;
      border-width: 4px;
      border-style: solid;
      border-radius: 50%;
    }
  }

/* spinner-1 styles */
.spinner.spinner-1 {
  
    @keyframes rotate-animation {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes anti-rotate-animation {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(-360deg);
    }
  }
  
  &:before {
    width: $main-spinner-dimensions;
    height: $main-spinner-dimensions;
    border-bottom-color: $basic-dark-color;
    border-right-color: $basic-dark-color;
    border-top-color: rgba($basic-dark-color, 0);
    border-left-color: rgba($basic-dark-color, 0);
    top: 0px;
    left: 0px;
    animation: rotate-animation 1s linear 0s infinite;
  }
  
  &:after {
    width: $small-spinner-dimensions;
    height: $small-spinner-dimensions;
    border-bottom-color: $basic-dark-color;
    border-right-color: $basic-dark-color;
    border-top-color: rgba($basic-dark-color, 0);
    border-left-color: rgba($basic-dark-color, 0);
    top: ($main-spinner-dimensions - $small-spinner-dimensions) / 2;
    left: ($main-spinner-dimensions - $small-spinner-dimensions) / 2;
    animation: anti-rotate-animation 0.85s linear 0s infinite;
  }
}
  // .side,
  // .loader-cube {
  //   width: 5em;
  //   height: 5em;
  // }
  // .loader-cube {
  //   transform-style: preserve-3d;
  //   animation: rotate 4s infinite ease-in-out;
  // }
  // .side {
  //   position: absolute;
  //   width: 5em;
  //   height: 5em;
  //   border: 0.05em solid #00a6e5;
  //   border-radius: 0.25em;
  //   transform-style: preserve-3d;
  //   background-size: contain;
  // }
  // .back {
  //   transform: translateZ(-2.5em) rotateY(180deg);
  //   background: #000
  //     url(https://kinosalut.ru/upload/resize_cache/iblock/3ad/70_100_1/3add3f7cf865e0654163f0c8bb242a4a.jpg)
  //     no-repeat;
  //   background-position-y: center;
  //   background-position-x: center;
  //   background-size: contain;
  // }
  // .left {
  //   transform: translateX(-2.5em) rotateY(-90deg);
  //   background: #000
  //     url(https://kinosalut.ru/upload/resize_cache/iblock/531/70_100_1/531d2def7f9fdd03c8725fe830fa928c.jpg)
  //     no-repeat;
  //   background-position-y: center;
  //   background-position-x: center;
  //   background-size: contain;
  // }
  // .right {
  //   transform: translateX(2.5em) rotateY(90deg);
  //   background: #000
  //     url(https://kinosalut.ru/upload/resize_cache/iblock/a36/70_100_1/a36c97220b82aa420f4cf4569990cdd4.jpg)
  //     no-repeat;
  //   background-position-y: center;
  //   background-position-x: center;
  //   background-size: contain;
  // }
  // .top {
  //   transform: translateY(-2.5em) rotateX(90deg);
  //   background: #000
  //     url(https://kinosalut.ru/upload/resize_cache/iblock/3a7/70_100_1/3a78bef03a979c42bced712e5a4a280a.jpg)
  //     no-repeat;
  //   background-position-y: center;
  //   background-position-x: center;
  //   background-size: contain;
  // }
  // .bottom {
  //   transform: translateY(2.5em) rotateX(-90deg);
  //   background: #000
  //     url(https://kinosalut.ru/upload/resize_cache/iblock/9b1/70_100_1/9b165fbab82043ce2e53f9beed6bacd7.jpg)
  //     no-repeat;
  //   background-position-y: center;
  //   background-position-x: center;
  //   background-size: contain;
  // }
  // .front {
  //   transform: translateZ(2.5em);
  //   background: #00a6e5 url(http://www.premierzal.ru/img/logo_new.png) no-repeat;
  //   background-position-y: center;
  //   background-position-x: center;
  //   background-size: contain;
  // }
  // @keyframes rotate {
  //   60% {
  //     transform: rotateX(360deg) rotateY(-360deg) rotateZ(360deg);
  //   }
  //   100% {
  //     transform: rotateX(360deg) rotateY(-360deg) rotateZ(360deg);
  //   }
  // }
}

@media only screen and (max-width: 320px) {
  #app {
    max-width: 320px;
  }
}
</style>
